export {
  DEFER_WELCOME_QUERY,
  WELCOME_FLOW_FLAG,
  ONBOARDING_ALLOWED_PATHS,
  isOnboardingAllowedPath,
} from '@arthelper/shared/onboarding';

/**
 * sessionStorage key the wizard writes the instant it observes a completed
 * session and that `OnboardingRedirect` reads as a synchronous backstop, so
 * we never bounce a freshly-completed user back to `/welcome` while the
 * ME_QUERY refetch is still in flight.
 */
export const welcomeCompletedKey = (asfId: string) => `arthelper:welcomeCompleted:${asfId}`;

/** localStorage key set when onboarding completes before Clerk asfId is available; cleared after conversion events fire. */
export const initiateCheckoutPendingKey = (sessionId: string) => `fb_initiate_checkout_pending_${sessionId}`;
